<template>
  <form
    class="relative"
    @submit.prevent="submit()"
  >
    <slot :errors="errors" />

    <slot name="submit" />

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <slot
        v-if="loading"
        name="loading"
      >
        <div class="absolute inset-0 flex items-center justify-center w-full h-full">
          <div
            class="absolute inset-0 w-full h-full opacity-80"
            :class="loadingMaskClass"
          />
          <i class="relative text-2xl mdi mdi-loading animate-spin text-primary-200" />
        </div>
      </slot>
    </transition>
  </form>
</template>

<script>

import { serialize } from "object-to-formdata";
import notificator from "@/services/notificator";

export default {
  name: "v-form",
  props: {
    data: {
      required: true,
      type: Object
    },
    url: {
      required: true,
      type: String
    },
    method: {
      required: true,
      type: String,
      validator (value) {
        return ["post", "patch"].indexOf(value) !== -1;
      }
    },
    format: {
      type: String,
      default() {
        return "json";
      },
      validator (value) {
        return ["json", "formData"].indexOf(value) !== -1;
      }
    },
    beforeSubmit: {
      default (next) {
        return next();
      },
      type: Function
    },
    onSuccess: {
      default (response) {
        notificator.success(response.data.message);
      },
      type: Function
    },
    onError: {
      default (error) {
        //
      },
      type: Function
    },
    loadingMaskClass: {
      default: "bg-white",
      type: String
    }
  },
  emits: ["success", "error"],
  data () {
    return {
      loading: false,
      errors: {}
    };
  },
  methods: {
    submit () {
      this.beforeSubmit(this.query);
    },
    query () {
      if (!this.loading) {
        this.loading = true;

        let method = this.method;
        let data = this.data;
        let headers = {"Content-Type": "application/json"};

        if (this.format == "formData") {
          method = "post";

          data = serialize(this.data, {
            nullsAsUndefineds: false,
            booleansAsIntegers: true,
            allowEmptyArrays: true
          });

          if (this.method != "post") {
            data.append("_method", this.method);
          }

          headers = {
            "Content-Type": "multipart/form-data",
          };
        }

        this.$http[method](this.url, data, {headers: headers})
          .then(response => {
            this.loading = false;
            this.errors = {};

            this.onSuccess(response);

            this.$emit("success", response);
          })
          .catch(error => {

            console.error(error);

            this.loading = false;

            if (error.response && error.response.status == 422) {
              this.loadErrors(error);
            }

            this.onError(error);

            this.$emit("error", error);
          });
      }
    },
    loadErrors (error) {
      this.errors = error.response.data.errors;
    },
    clearErrors (name = null) {
      if (name == null) {
        this.errors = {};
      } else {
        delete this.errors[name];
      }
    }
  }
};
</script>
